/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MdFlight } from 'react-icons/md';
import {
  getFlightTicketApi,
  addMarkupInTicket,
  addBaggageInTicket,
  showInPdf,
  emailFlightOptions,
} from '../../api/flightApi';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
  checkValidEmailAddress,
} from '../../shared/constants/Constants';
import {
  convertTravelTime,
  formatBookingDate,
  formatDate,
  formatTimeString,
  getBookingClassText,
  hideHeaderFooter,
  showHeaderFooter,
  getConnectingTime,
  formatCurrency,
  getNewDate,
  isEmpty,
  isNullOrEmpty,
  poupMessageInTicket,
} from '../../shared/helper-utils/appUtils';
import {
  getObjectFromLS,
  getStringFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppButton from '../../shared/components/app-button/AppButton';
import './FlightTicketPage.scss';
import AppModal from '../../shared/components/app-modal/AppModal';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import { AIRLINE_NAMES_FOR_CARRIER_CODE } from '../../shared/constants/FlightCarrierNames';
import { useAppContext } from '../../saas/AppConfigWrapper';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';
import {
  APP_AGENT_LOGO_URL,
  APP_LOGO_URL,
  APP_USER_PROFILE,
} from '../../saas/AppStorageStaticNames';
import FlightPerPaxTicketModal from './FlightPerPaxTicketModal';

const CABIN_CLASS_LABELS = {
  economy: 'Economy',
  premiumeconomy: 'Premium Economy',
  business: 'Business',
  premiumbusiness: 'Premium Business',
  first: 'First Class',
};

const formatCabinClass = (cabinClass) => {
  if (isEmpty(cabinClass)) return '';
  const key = cabinClass.toLowerCase().replace(/\s+/g, '');
  return CABIN_CLASS_LABELS[key] || cabinClass;
};

function FlightNewTicketPage() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const { transactionId } = useParams();
  const [showFare, setShowFare] = useState(true);
  const [hasTicket, setHasTicket] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const flightInvoiceRef = useRef(null);
  const paymentSummaryRef = useRef(null);
  const passengerRef = useRef(null);
  const fareSummaryRef = useRef({});
  const flightSectorsRef = useRef({});
  const taxNodesRef = useRef([]);
  const sectorFareTypesRef = useRef({});
  const sectorFullNameMapRef = useRef({});
  const barCodesRef = useRef([]);
  const agentDetailsRef = useRef(null);
  const flightTicketRef = useRef(null);
  const fareDetailsStrRef = useRef([]);
  const [showGstDetails, setShowGstDetails] = useState(false);
  const onwardSectorRef = useRef([]);
  const returnSectorRef = useRef([]);
  const [showMarkupModal, setShowMarkupModal] = useState(false);
  const [markupToAdd, setMarkupToAdd] = useState('');
  const [showBaggageModal, setShowBaggageModal] = useState(false);
  const [baggageToAdd, setBaggageToAdd] = useState('');
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [toEmail, setToEmail] = useState('');
  const [alert, setAlert] = useState(undefined);
  const paxDetailsRef = useRef([]);
  const [hasSSR, setHasSSR] = useState(false);
  const onwardSectorKeysRef = useRef([]);
  const returnSectorKeysRef = useRef([]);
  const originRef = useRef('');
  const destinationRef = useRef('');
  const [showPerPaxTicketModal, setShowPerPaxTicketModal] = useState(false);
  const [imageLoadError, setImageLoadError] = useState(false);
  const [showConfirmationPoup, setShowConfirmationPopup] = useState(false);
  const [showAgency, setShowAgency] = useState(true);

  useEffect(() => {
    hideHeaderFooter();
    return () => showHeaderFooter();
  }, []);

  const getLayoverTime = (arrtime, arrdate, deptime, depdate) => {};

  const setFareSummary = (data) => {
    const invoice = data.FullFlightDetails.FlightInvoice;

    let FlightApiPricingLog = [];
    if (!isEmpty(invoice?.UpdatedFlightApiPricingLogs?.FlightApiPricingLog)) {
      FlightApiPricingLog =
        invoice.UpdatedFlightApiPricingLogs.FlightApiPricingLog;
    } else {
      FlightApiPricingLog =
        invoice?.FlightApiPricingLogs?.FlightApiPricingLog || [];
    }
    FlightApiPricingLog = Array.isArray(FlightApiPricingLog)
      ? FlightApiPricingLog
      : [FlightApiPricingLog];
    let kValue = 0;
    FlightApiPricingLog.forEach((log) => {
      let FullBreakup = {};
      if (log?.ResponseXml) {
        FullBreakup = log?.ResponseXml.FullBreakup;
      }
      kValue +=
        (FullBreakup?.AdultJn || 0) * invoice.FlightRecord.NumAdults +
        (FullBreakup?.ChildJn || 0) * invoice.FlightRecord.NumChildren +
        (FullBreakup?.InfantJn || 0) * invoice.FlightRecord.NumInfants;
    });
    fareSummaryRef.current = {
      totalFare: 0,
    };
    fareSummaryRef.current.kvalue = kValue;

    let { PassengerSSRRecord } = invoice.PassengerSSRRecords;
    if (PassengerSSRRecord !== undefined && PassengerSSRRecord !== '') {
      PassengerSSRRecord = Array.isArray(PassengerSSRRecord)
        ? PassengerSSRRecord
        : [PassengerSSRRecord];
    } else {
      PassengerSSRRecord = [];
    }
    let ssrAmount = 0;
    let seatPrice = 0;
    let mealPrice = 0;
    let baggagePrice = 0;
    let specialSsrPrice = 0;
    let hasSeat = false;
    let hasMeal = false;
    let hasBaggage = false;
    let hasSpecialSsr = false;
    PassengerSSRRecord.forEach((record) => {
      if (
        record.SSRType.toLowerCase() === 'seat' &&
        record.Status !== 'failed'
      ) {
        seatPrice += parseInt(record.ChargeableAmount, 10);
        hasSeat = true;
      }
      if (
        record.SSRType.toLowerCase() === 'meal' &&
        record.Status !== 'failed'
      ) {
        mealPrice += parseInt(record.ChargeableAmount, 10);
        hasMeal = true;
      }
      if (
        record.SSRType.toLowerCase() === 'baggage' &&
        record.Status !== 'failed'
      ) {
        baggagePrice += parseInt(record.ChargeableAmount, 10);
        hasBaggage = true;
      }
      if (
        record.SSRType.toLowerCase() === 'specialssr' &&
        record.Status !== 'failed'
      ) {
        specialSsrPrice += parseInt(record.ChargeableAmount, 10);
        hasSpecialSsr = true;
      }
      ssrAmount += record.ChargeableAmount;
    });
    fareSummaryRef.current.ssrValue = ssrAmount;
    fareSummaryRef.current.hasSeat = hasSeat;
    fareSummaryRef.current.hasMeal = hasMeal;
    fareSummaryRef.current.hasBaggage = hasBaggage;
    fareSummaryRef.current.hasSpecialSsr = hasSpecialSsr;
    fareSummaryRef.current.seatPrice = seatPrice;
    fareSummaryRef.current.mealPrice = mealPrice;
    fareSummaryRef.current.baggagePrice = baggagePrice;
    fareSummaryRef.current.specialSsrPrice = specialSsrPrice;
    fareDetailsStrRef.current =
      invoice.FlightRecord.FareDetails.split('##').map(Number);
    fareSummaryRef.current.baseFare = fareDetailsStrRef.current[0];
    fareSummaryRef.current.surcharge =
      fareDetailsStrRef.current[1] + fareDetailsStrRef.current[8];
    fareSummaryRef.current.gst = fareDetailsStrRef.current[3];
    fareSummaryRef.current.yq = fareDetailsStrRef.current[2];
    fareSummaryRef.current.otherTaxes =
      fareSummaryRef.current.surcharge -
      fareSummaryRef.current.yq -
      fareSummaryRef.current.kvalue;
    fareSummaryRef.current.processingFee = fareDetailsStrRef.current[6];
    fareSummaryRef.current.grandTotal = fareDetailsStrRef.current[11];
  };

  const getNameById = (id) => {
    const record = passengerRef.current.find((pax) => pax.Paxid === id);
    return `${record.Title} ${record.FirstName} ${record.LastName}`;
  };

  const extractFFN = (formattedString, str1) => {
    const regex = new RegExp(`^${str1}${str1}(.*)$`);
    const match = formattedString.match(regex);
    return match ? match[1] : null;
  };

  const getJourneyFFN = (sec, ffn) => {
    try {
      if (!isEmpty(sec) && !isEmpty(ffn)) {
        if (ffn.split(',').length > 1) {
          if (sec.FlightType.toLowerCase() === 'onward') {
            if (extractFFN(ffn.split(',')[0], sec.Carrier)) {
              return extractFFN(ffn.split(',')[0], sec.Carrier);
            }
          }
          if (sec.FlightType.toLowerCase() === 'return') {
            if (extractFFN(ffn.split(',')[1], sec.Carrier)) {
              return extractFFN(ffn.split(',')[1], sec.Carrier);
            }
          }
        } else {
          if (sec.FlightType.toLowerCase() === 'onward') {
            if (
              onwardSectorRef.current[0].Carrier.substring(0, 2) ===
              ffn.substring(0, 2)
            ) {
              if (extractFFN(ffn.split(',')[0], sec.Carrier)) {
                return extractFFN(ffn.split(',')[0], sec.Carrier);
              }
            }
          }
          if (sec.FlightType.toLowerCase() === 'return') {
            if (
              returnSectorRef.current[0].Carrier.substring(0, 2) ===
              ffn.substring(0, 2)
            ) {
              if (extractFFN(ffn.split(',')[0], sec.Carrier)) {
                return extractFFN(ffn.split(',')[0], sec.Carrier);
              }
            }
          }
        }
      }
      return '';
    } catch (error) {
      return '';
    }
  };

  const getData = async () => {
    setIsLoading(true);
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const response = await getFlightTicketApi(
      transactionId,
      userProfile?.agentId,
    );
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      const { FlightInvoice, UserDetails } =
        response.ApiStatus.Result.FullFlightDetails;
      flightInvoiceRef.current = FlightInvoice;
      agentDetailsRef.current = UserDetails.UserProfile;
      originRef.current = FlightInvoice.FlightRecord.Origin;
      destinationRef.current = FlightInvoice.FlightRecord.Destination;
      const { FlightTicket } = FlightInvoice.FlightTickets;
      flightTicketRef.current = Array.isArray(FlightTicket)
        ? FlightTicket
        : [FlightTicket];
      if (FlightInvoice.BarCodes) {
        barCodesRef.current = Array.isArray(FlightInvoice.BarCodes.BarCode)
          ? FlightInvoice.BarCodes.BarCode
          : [FlightInvoice.BarCodes.BarCode];
      }
      let { SectorRecord } = flightInvoiceRef.current.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      sectorFareTypesRef.current = SectorRecord.reduce((acc, cur) => {
        if (!acc[cur]) {
          acc[`${cur.Origin} - ${cur.Destination}`] = cur.Faretype;
        }
        return acc;
      }, {});
      sectorFullNameMapRef.current = SectorRecord.reduce((acc, sector) => {
        if (acc[sector.Origin] === undefined) {
          acc[sector.Origin] =
            sector.OriginFullName === '-'
              ? sector.Origin
              : sector.OriginFullName;
        }
        if (acc[sector.Destination] === undefined) {
          acc[sector.Destination] =
            sector.DestinationFullName === '-'
              ? sector.Destination
              : sector.DestinationFullName;
        }
        return acc;
      }, {});
      flightSectorsRef.current = SectorRecord;
      flightSectorsRef.current.forEach((record) => {
        const arrDate = record.ArrivalDate;
        if (arrDate.toString().includes('-') === false) {
          const dateString = `${arrDate}`.replace(
            /(\d{4})(\d{2})(\d{2})/,
            '$1-$2-$3',
          );
          record.ArrivalDate = dateString;
        }
      });
      onwardSectorRef.current = flightSectorsRef.current.filter(
        (sector) => sector.FlightType.toLowerCase() === 'onward',
      );
      returnSectorRef.current = flightSectorsRef.current.filter(
        (sector) => sector.FlightType.toLowerCase() === 'return',
      );
      const onwardKeys = [];
      const returnKeys = [];
      onwardSectorRef.current.forEach((sector) =>
        onwardKeys.push(`${sector.Origin} - ${sector.Destination}`),
      );
      if (returnSectorRef.current.length > 0) {
        returnSectorRef.current.forEach((sector) =>
          returnKeys.push(`${sector.Origin} - ${sector.Destination}`),
        );
      }
      onwardSectorKeysRef.current = onwardKeys;
      returnSectorKeysRef.current = returnKeys;

      paymentSummaryRef.current = {
        TotalAmount:
          FlightInvoice.FlightRecord.FareQuoteAmount +
          FlightInvoice.AdditionalMarkup +
          FlightInvoice.FlightRecord.SSRAmount,
        SSRAmount: FlightInvoice.FlightRecord.SSRAmount,
        AdditionalMarkup: FlightInvoice.AdditionalMarkup,
        PaymentMode: FlightInvoice.FlightRecord.PaymentMode,
        PaymentStatus: FlightInvoice.FlightRecord.PaymentStatus,
        BookingDate: FlightInvoice.FlightRecord.BookingDate,
      };
      let { PassengerSSRRecord } = flightInvoiceRef.current.PassengerSSRRecords;
      if (PassengerSSRRecord !== undefined && PassengerSSRRecord !== '') {
        PassengerSSRRecord = Array.isArray(PassengerSSRRecord)
          ? PassengerSSRRecord
          : [PassengerSSRRecord];
      } else {
        PassengerSSRRecord = [];
      }
      if (PassengerSSRRecord.length > 0) {
        setHasSSR(true);
      }
      let { PassengerRecord } = flightInvoiceRef.current.PassengerRecords;
      PassengerRecord = Array.isArray(PassengerRecord)
        ? PassengerRecord
        : [PassengerRecord];
      passengerRef.current = PassengerRecord;
      const newArray = [];
      passengerRef.current.forEach((pax) => {
        const paxAvail = newArray.find(
          (record) =>
            record.name === `${pax.Title} ${pax.FirstName} ${pax.LastName}`,
        );
        if (!paxAvail) {
          newArray.push({
            name: `${pax.Title} ${pax.FirstName} ${pax.LastName}`,
          });
        }
      });
      paxDetailsRef.current = newArray;
      paxDetailsRef.current.forEach((pax) => {
        const paxSectors = [];
        const paxJourney = [];
        passengerRef.current.forEach((passenger) => {
          if (
            `${passenger.Title} ${passenger.FirstName} ${passenger.LastName}` ===
            pax.name
          ) {
            flightSectorsRef.current.forEach((sector) => {
              const meal = [];
              const seat = [];
              const baggage = [];
              const specialSSR = [];
              const additionalinfo = [];
              if (PassengerSSRRecord.length > 0) {
                PassengerSSRRecord.forEach((record) => {
                  if (
                    record.Origin === sector.Origin &&
                    record.Destination === sector.Destination &&
                    record.Paxid === passenger.Paxid
                  ) {
                    if (record.SSRType === 'meal') {
                      meal.push(record.SSR);
                    }
                    if (record.SSRType === 'seat') {
                      seat.push(record.SSRCode);
                      additionalinfo.push(record.AdditionalInfo);
                    }
                    if (record.SSRType === 'baggage') {
                      baggage.push(record.SSR);
                    }
                    if (record.SSRType === 'specialssr') {
                      specialSSR.push(record.SSR);
                    }
                  } else if (
                    record.Origin === originRef.current &&
                    record.Destination === destinationRef.current &&
                    record.Paxid === passenger.Paxid &&
                    record.TripNumber === 1
                  ) {
                    if (record.SSRType === 'baggage') {
                      baggage.push(record.SSR);
                    }
                    if (record.SSRType === 'specialssr') {
                      specialSSR.push(record.SSR);
                    }
                  } else if (
                    record.Destination === originRef.current &&
                    record.Origin === destinationRef.current &&
                    record.Paxid === passenger.Paxid &&
                    record.TripNumber === 2
                  ) {
                    if (record.SSRType === 'baggage') {
                      baggage.push(record.SSR);
                    }
                    if (record.SSRType === 'specialssr') {
                      specialSSR.push(record.SSR);
                    }
                  }
                });
              }
              const paxSector = barCodesRef.current.find(
                (record) =>
                  record.Paxid === passenger.Paxid &&
                  `${record.Origin}-${record.Destination}` ===
                    `${sector.Origin}-${sector.Destination}`,
              );
              if (paxSector) {
                paxSectors.push({
                  sectorInfo: `${paxSector.Origin}-${paxSector.Destination}`,
                  sectorBaggage:
                    typeof sector?.BaggageInfo === 'string'
                      ? sector.BaggageInfo.split(',')[0]
                      : sector?.BaggageInfo,

                  sectorBarcode: paxSector.ImagePath,
                  sectorSSr: [seat, meal, baggage, specialSSR, additionalinfo],
                  sectorFFN: getJourneyFFN(
                    sector,
                    passenger.FrequentFlyerNumber,
                  ),
                });
              }
            });
            const paxTicket = flightTicketRef.current.find(
              (ticket) => ticket.Paxid === passenger.Paxid,
            );
            if (paxTicket) {
              paxJourney.push({
                journeyStatus: passenger.Status,
                journeyPnr: paxTicket.AirlinePnr,
                journeyTicket: paxTicket.TicketNumber,
                journeyFFN: paxTicket.FFNNumber,
              });
            }
            pax.paxType = passenger.Type;
            pax.passport = passenger.Passport;
            pax.dob = passenger.Dob;
            pax.passportExpiry = passenger.PassportExpiry;
            pax.Paxid = passenger.Paxid;
          }
        });
        pax.paxSectors = paxSectors;
        pax.paxJourney = paxJourney;
        pax.onwardsectorsLength = onwardSectorRef.current.length;
        pax.returnsectorsLength = returnSectorRef.current.length;
      });
      setFareSummary(response.ApiStatus.Result);
      setHasTicket(true);
      setIsLoading(false);
      if (
        [
          'pending',
          'rolledback',
          'blocked',
          'queueprocessing',
          'queued',
        ].indexOf(FlightInvoice.FlightRecord.BookingStatus.toLowerCase()) > -1
      ) {
        setShowConfirmationPopup(true);
      }
    } else {
      setAlert({
        title: 'Flight Ticket',
        description: response.ApiStatus?.Message
          ? response.ApiStatus?.Message
          : 'Failed to load details',
        variant: 'error',
      });
      setHasTicket(false);
      setIsLoading(false);
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
  };

  useEffect(() => {
    getData();
  }, [transactionId]);

  const handleAddMarkup = async () => {
    if (markupToAdd === '') {
      return false;
    }
    setIsLoading(true);
    const res = await addMarkupInTicket(
      getUserAgentId(),
      transactionId,
      markupToAdd,
    );
    if (res.Root.Status === 'OK') {
      getData();
      setShowMarkupModal(false);
      setMarkupToAdd('');
    } else {
      setIsLoading(false);
      setAlert({
        title: 'Add Markup',
        description: res.Root?.Message ? res.Root?.Message : 'cant add markup',
        variant: 'error',
      });
    }
  };
  const handleAddBaggage = async () => {
    if (baggageToAdd === '') {
      return false;
    }
    setIsLoading(true);
    const res = await addBaggageInTicket(
      getUserAgentId(),
      transactionId,
      baggageToAdd,
    );
    if (res.Root.Status === 'OK') {
      setShowBaggageModal(false);
      getData();
      setBaggageToAdd('');
    } else {
      setIsLoading(false);
      setAlert({
        title: 'Show Pdf',
        description: res.Root?.Message
          ? res.Root?.Message
          : 'Error Showing Pdf ',
        variant: 'error',
      });
    }
  };

  const handleShowPdf = async () => {
    setIsLoading(true);
    const htmlContent = document.getElementById('ticketPrint').innerHTML;
    const updatedContent = htmlContent.replace(
      /₹/g,
      `${appConfig?.appCurrency}`,
    );
    const res = await showInPdf(
      getUserAgentId(),
      updatedContent,
      transactionId,
    );
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      const resUrl = res.ApiStatus.Result;
      window.open(resUrl, '_blank');
    } else {
      setAlert({
        title: 'Show Pdf',
        description: res.ApiStatus?.Message
          ? res?.ApiStatus?.Message
          : 'Error Showing Pdf ',
        variant: 'error',
      });
    }
    setIsLoading(false);
  };

  const handleSendEmail = async () => {
    const fromName = `${agentDetailsRef.current.FirstName} ${agentDetailsRef.current.LastName}`;
    const fromEmail = agentDetailsRef.current.ContactEmail;
    const htmlContent = document.getElementById('ticketPrint').innerHTML;
    const mailSubject = `Your Flight Booking Details : ${transactionId}`;
    if (toEmail === '' || checkValidEmailAddress(toEmail)) {
      setAlert({
        title: 'Email',
        description: 'please enter valid email',
        variant: 'error',
      });
      return false;
    }
    setIsLoading(true);
    const response = await emailFlightOptions(
      fromEmail,
      fromName,
      toEmail,
      htmlContent,
      mailSubject,
    );
    if (response.Root.Status === 'OK') {
      setShowEmailModal(false);
      setToEmail('');
      setAlert({
        title: 'Email',
        description: 'Email Sent Successfully',
        variant: 'success',
      });
    } else {
      setAlert({
        title: 'Email',
        description: 'Failed to send Email Please try again',
        variant: 'error ',
      });
    }
    setIsLoading(false);
  };

  const getTerminal = (terminal) => {
    if (
      terminal !== undefined &&
      terminal !== null &&
      terminal !== '' &&
      terminal !== '-'
    ) {
      const terNumber = terminal
        .toLowerCase()
        .replace('terminal', '')
        .replace('t', '');
      return `${terNumber}`;
    }
    return '';
  };

  const handleDownloadPerPaxTicket = async (htmlContent) => {
    setShowPerPaxTicketModal(false);
    setIsLoading(true);
    // const base64String = btoa(unescape(encodeURIComponent(htmlContent)));
    const res = await showInPdf(getUserAgentId(), htmlContent, transactionId);
    if (res && res?.ApiStatus?.Status === 'OK') {
      const resUrl = res.ApiStatus.Result;
      window.open(resUrl, '_blank');
    } else {
      setAlert({
        title: 'Show Pdf',
        description: res?.ApiStatus?.Message
          ? res?.ApiStatus?.Message
          : 'Error Showing Pdf ',
        variant: 'error',
      });
    }
    setIsLoading(false);
  };

  return (
    <section className="flight-ticket-page">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {hasTicket !== undefined && hasTicket && (
        <section
          style={{
            padding: '1rem 10px',
            // width: '900px',
            maxWidth: '900px',
            width: '100%',
            marginInline: 'auto',
          }}
          id="ticketPrint"
        >
          {showAgency && (
            <div id="ticketHeader" className="d-block">
              <div
                style={{
                  padding: '8px',
                  borderBottom: '1px solid #ccc',
                  marginBottom: '10px',
                }}
                className="avoid-page-break-in-print"
              >
                <div>
                  <table
                    style={{ width: '100%', borderSpacing: '0' }}
                    className="avoid-page-break-in-print"
                  >
                    <tbody>
                      <tr>
                        <td width="50%">
                          <div>
                            {!imageLoadError &&
                            !isNullOrEmpty(
                              getStringFromLS(APP_AGENT_LOGO_URL),
                            ) ? (
                              <img
                                src={getStringFromLS(APP_AGENT_LOGO_URL)}
                                alt=""
                                style={{
                                  maxHeight: `${appConfig.logoHeight}px`,
                                }}
                                onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.target.src = null;
                                  setImageLoadError(true);
                                }}
                              />
                            ) : (
                              <img
                                src={getStringFromLS(APP_LOGO_URL)}
                                alt=""
                                style={{
                                  maxHeight: `${appConfig.logoHeight}px`,
                                }}
                                onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.target.src = null;
                                }}
                              />
                            )}
                          </div>
                        </td>
                        <td width="50%">
                          <table
                            style={{
                              fontSize: '12px',
                              fontWeight: '500',
                              lineHeight: '16px',
                              borderSpacing: '0',
                              textAlign: 'end',
                              width: '100%',
                            }}
                            className="avoid-page-break-in-print"
                          >
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    color: 'red',
                                    fontWeight: '600',
                                  }}
                                >
                                  <span>{agentDetailsRef.current.Company}</span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span>
                                    {agentDetailsRef.current.Address1}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  {`${agentDetailsRef.current.City}, ${agentDetailsRef.current.State}-${agentDetailsRef.current.PinCode}, ${agentDetailsRef.current.Country}`}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Phone Number :{' '}
                                  {agentDetailsRef.current.ContactNumber}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Email Id :{' '}
                                  {agentDetailsRef.current.ContactEmail}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
          <div
            style={{
              margin: '10px',
              borderRadius: '6px',
              overflow: 'hidden',
              fontSize: '14px',
              boxShadow: '0px 0px 10px 2px #0000001A',
            }}
            className="avoid-page-break-in-print"
          >
            <div style={{ overflowX: 'auto' }}>
              <table
                style={{ width: '100%' }}
                className="avoid-page-break-in-print"
              >
                <thead
                  style={{
                    backgroundColor: appConfig?.clientPrimaryColor,
                    color: '#fff',
                  }}
                >
                  <tr>
                    <td colSpan={5} style={{ padding: '3px 16px' }}>
                      Booking Details [
                      {flightInvoiceRef.current.FlightRecord.BookingStatus?.toLowerCase() ===
                      'confirmed'
                        ? 'Confirmed'
                        : flightInvoiceRef.current.FlightRecord.BookingStatus}
                      ]
                    </td>
                  </tr>
                </thead>
                <tbody style={{ textAlign: 'center' }}>
                  <tr>
                    <td
                      style={{
                        backgroundColor: '#f5f5f5',
                        fontWeight: '500',
                        padding: '5px',
                      }}
                    >
                      Booking ID
                    </td>
                    <td
                      style={{
                        backgroundColor: '#f5f5f5',
                        fontWeight: '500',
                        padding: '5px',
                        textAlign: 'center',
                      }}
                    >
                      GDS PNR
                    </td>
                    <td
                      style={{
                        backgroundColor: '#f5f5f5',
                        fontWeight: '500',
                        padding: '5px',
                        textAlign: 'center',
                      }}
                    >
                      Airline PNR
                    </td>
                    <td
                      style={{
                        backgroundColor: '#f5f5f5',
                        fontWeight: '500',
                        padding: '5px',
                        textAlign: 'center',
                      }}
                    >
                      Booking Date
                    </td>
                    {/* <td
                    style={{
                      backgroundColor: '#f5f5f5',
                      fontWeight: '500',
                      padding: '5px',
                      textAlign: 'center',
                    }}
                  >
                    Airline
                  </td> */}
                  </tr>
                  <tr>
                    <td style={{ color: '#666666', padding: '5px' }}>
                      {flightInvoiceRef.current.FlightRecord.Txid}
                    </td>
                    <td style={{ color: '#666666', padding: '5px' }}>
                      {flightInvoiceRef.current.FlightRecord.GdsPnr}
                    </td>
                    <td style={{ color: '#666666', padding: '5px' }}>
                      {flightInvoiceRef.current.FlightRecord.AirlinePnr}
                    </td>
                    <td style={{ color: '#666666', padding: '5px' }}>
                      {formatBookingDate(
                        flightInvoiceRef.current.FlightRecord.BookingDate,
                      )}
                    </td>
                    {/* <td style={{ color: '#666666', padding: '5px' }}>
                    {onwardSectorRef.current[0].CarrierName}
                  </td> */}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            style={{
              backgroundColor: appConfig?.clientPrimaryColor,
              padding: '3px 16px',
              color: '#fff',
              margin: '10px',
              borderRadius: '6px',
              fontSize: '14px',
              overflow: 'hidden',
            }}
            className="avoid-page-break-in-print"
          >
            <div style={{ overflowX: 'auto' }}>
              <table width="100%" className="avoid-page-break-in-print">
                <tbody>
                  <tr>
                    <td
                      style={{
                        textAlign: 'start',
                        width: '100%',
                        fontWeight: '500',
                      }}
                    >
                      Flight Details
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            style={{ fontSize: '12px', color: '#666666', margin: '10px' }}
            className="avoid-page-break-in-print"
          >
            Subject to prior sale, price and schedule changes. In large parts
            air fares can only be cancelled or rebooked for a fee. These fees
            may consist up to 100% of the air fare. Detailed conditions can be
            obtained from your travel agent or tour operator.
          </div>
          <div
            style={{
              fontSize: '11px',
              margin: '10px',
              borderRadius: '6px',
              overflow: 'hidden',
              color: '#666666',
              border: '1px solid #e2e2e2',
              fontWeight: '300',
            }}
            className="avoid-page-break-in-print"
          >
            <div style={{ overflowX: 'auto' }}>
              <table width="100%" className="avoid-page-break-in-print">
                <tbody>
                  <tr>
                    <td
                      style={{
                        backgroundColor: '#f5f5f5',
                        fontWeight: '600',
                        padding: '5px 16px',
                        fontSize: '13px',
                        color: '#333',
                        borderBottom: '1px solid #e2e2e2',
                        borderRight: '1px solid #e2e2e2',
                        textAlign: 'start',
                      }}
                      colSpan={7}
                    >
                      {flightInvoiceRef.current.FlightRecord.Origin} -{' '}
                      {flightInvoiceRef.current.FlightRecord.Destination}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        borderBottom: '1px solid #e2e2e2',
                        color: '#000',
                        fontWeight: '500',
                        backgroundColor: '#f5f5f5',
                        borderRight: '1px solid #e2e2e2',
                        width: '105px',
                        padding: '3px',
                      }}
                    >
                      <div>Carrier /</div>
                      <div>Dep Date</div>
                    </td>
                    <td
                      style={{
                        borderBottom: '1px solid #e2e2e2',
                        borderRight: '1px solid #e2e2e2',
                        color: '#000',
                        fontWeight: '500',
                        backgroundColor: '#f5f5f5',
                        width: '80px',
                        padding: '3px',
                      }}
                    >
                      <div>Flight No</div>
                    </td>
                    <td
                      style={{
                        borderBottom: '1px solid #e2e2e2',
                        borderRight: '1px solid #e2e2e2',
                        color: '#000',
                        fontWeight: '500',
                        backgroundColor: '#f5f5f5',
                        width: '225px',
                        padding: '3px',
                      }}
                    >
                      <div>Departure /</div>
                      <div>Dep Terminal</div>
                    </td>
                    <td
                      style={{
                        borderBottom: '1px solid #e2e2e2',
                        borderRight: '1px solid #e2e2e2',
                        color: '#000',
                        fontWeight: '500',
                        backgroundColor: '#f5f5f5',
                        width: '225px',
                        padding: '3px',
                      }}
                    >
                      <div>Arrival /</div>
                      <div>Arr Terminal</div>
                    </td>
                    <td
                      style={{
                        borderBottom: '1px solid #e2e2e2',
                        borderRight: '1px solid #e2e2e2',
                        color: '#000',
                        fontWeight: '500',
                        backgroundColor: '#f5f5f5',
                        width: '70px',
                        padding: '3px',
                      }}
                    >
                      <div>Dep Time/</div>
                      <div>Dep Date</div>
                    </td>
                    <td
                      style={{
                        borderBottom: '1px solid #e2e2e2',
                        borderRight: '1px solid #e2e2e2',
                        color: '#000',
                        fontWeight: '500',
                        backgroundColor: '#f5f5f5',
                        width: '70px',
                        padding: '3px',
                      }}
                    >
                      <div>Arr Time/</div>
                      <div>Arr Date</div>
                    </td>
                    <td
                      style={{
                        borderBottom: '1px solid #e2e2e2',
                        color: '#000',
                        fontWeight: '500',
                        backgroundColor: '#f5f5f5',
                        padding: '3px',
                      }}
                    >
                      <div>Duration /</div>
                      <div>Cabin Class</div>
                    </td>
                  </tr>
                  {onwardSectorRef.current.length > 0 &&
                    onwardSectorRef.current.map((sector, index) => {
                      const finalDestination =
                        onwardSectorRef.current[
                          onwardSectorRef.current.length - 1
                        ].Destination;
                      return (
                        <React.Fragment
                          key={`${sector.Origin}-${sector.Destination}`}
                        >
                          <tr>
                            <td
                              style={{
                                padding: '3px',
                                verticalAlign: 'top',
                                width: '105px',
                                borderRight: '1px solid #e2e2e2',
                              }}
                            >
                              <table className="avoid-page-break-in-print">
                                <tbody>
                                  <tr>
                                    <td>
                                      <AppFlightLogo
                                        className="vertical-bottom"
                                        carrier={sector.Carrier.substring(0, 2)}
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                          marginLeft: '5px',
                                        }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      {
                                        AIRLINE_NAMES_FOR_CARRIER_CODE[
                                          sector.Carrier.substring(0, 2)
                                        ]
                                      }
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      {formatDate(
                                        getNewDate(sector.JourneyDate),
                                        DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{
                                padding: '3px',
                                verticalAlign: 'top',
                                width: '80px',
                                borderRight: '1px solid #e2e2e2',
                              }}
                            >
                              <div>
                                {`${sector.Carrier}-${sector.FlightNumber}`}
                              </div>
                              <div>
                                {/* Equipment: airbus-321 */}
                                {sector.Equipment === null
                                  ? ''
                                  : `Equipment: ${sector.Equipment} ${sector.FlightModel}`}
                              </div>
                            </td>
                            <td
                              style={{
                                padding: '3px',
                                verticalAlign: 'top',
                                width: '225px',
                                borderRight: '1px solid #e2e2e2',
                              }}
                            >
                              <table className="avoid-page-break-in-print">
                                <tbody>
                                  <tr>
                                    <td style={{ color: '#333' }}>
                                      {sector.OriginAirportFullname} (
                                      {sector.Origin})
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ color: '#333' }}>
                                      {getTerminal(
                                        sector.AirportTerminal.split(',')[0],
                                      ) !== ''
                                        ? `Terminal: ${getTerminal(
                                            sector.AirportTerminal.split(
                                              ',',
                                            )[0],
                                          )}`
                                        : ''}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{
                                padding: '3px',
                                verticalAlign: 'top',
                                width: '225px',
                                borderRight: '1px solid #e2e2e2',
                              }}
                            >
                              <table className="avoid-page-break-in-print">
                                <tbody>
                                  <tr>
                                    <td style={{ color: '#333' }}>
                                      {sector.DestinationAirportFullname} (
                                      {sector.Destination})
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ color: '#333' }}>
                                      {getTerminal(
                                        sector.AirportTerminal.split(',')[1],
                                      ) !== ''
                                        ? `Terminal: ${getTerminal(
                                            sector.AirportTerminal.split(
                                              ',',
                                            )[1],
                                          )}`
                                        : ''}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{
                                padding: '3px',
                                verticalAlign: 'top',
                                width: '70px',
                                borderRight: '1px solid #e2e2e2',
                              }}
                            >
                              <table className="avoid-page-break-in-print">
                                <tbody>
                                  <tr>
                                    <td style={{ color: '#333' }}>
                                      {formatTimeString(sector.DepartureTime)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ color: '#333' }}>
                                      {formatDate(
                                        getNewDate(sector.JourneyDate),
                                        DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{
                                padding: '3px',
                                verticalAlign: 'top',
                                width: '70px',
                                borderRight: '1px solid #e2e2e2',
                              }}
                            >
                              <table>
                                <tbody>
                                  <tr>
                                    <td style={{ color: '#333' }}>
                                      {formatTimeString(sector.ArrivalTime)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ color: '#333' }}>
                                      {formatDate(
                                        getNewDate(sector.ArrivalDate),
                                        DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{
                                padding: '3px',
                                verticalAlign: 'top',
                                color: '#333',
                              }}
                            >
                              <div>
                                {convertTravelTime(sector.SectorDuration)}
                              </div>
                              <div>
                                {formatCabinClass(
                                  flightInvoiceRef.current.FlightRecord
                                    .CabinClass,
                                ) || getBookingClassText(sector.BookingClass)}
                              </div>
                            </td>
                          </tr>
                          {sector.Destination !== finalDestination && (
                            <tr>
                              <td
                                style={{
                                  textAlign: 'center',
                                  color: '#374471',
                                  fontWeight: '500',
                                  backgroundColor: '#fce5e6',
                                }}
                                colSpan="7"
                              >
                                {getConnectingTime(
                                  sector.ArrivalTime,
                                  sector.ArrivalDate,
                                  onwardSectorRef.current[index + 1]
                                    .DepartureTime,
                                  onwardSectorRef.current[index + 1]
                                    .JourneyDate,
                                )}{' '}
                                layover in {sector.Destination}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
          {returnSectorRef.current.length > 0 && (
            <div
              style={{
                fontSize: '11px',
                margin: '10px',
                borderRadius: '6px',
                overflow: 'hidden',
                color: '#666666',
                border: '1px solid #e2e2e2',
                fontWeight: '300',
              }}
              className="avoid-page-break-in-print"
            >
              <div style={{ overflowX: 'auto' }}>
                <table width="100%" className="avoid-page-break-in-print">
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          padding: '5px 16px',
                          fontSize: '13px',
                          color: '#333',
                          borderBottom: '1px solid #e2e2e2',
                          borderRight: '1px solid #e2e2e2',
                          textAlign: 'start',
                        }}
                        colSpan={7}
                      >
                        {flightInvoiceRef.current.FlightRecord.Destination} -{' '}
                        {flightInvoiceRef.current.FlightRecord.Origin}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid #e2e2e2',
                          color: '#000',
                          fontWeight: '500',
                          backgroundColor: '#f5f5f5',
                          borderRight: '1px solid #e2e2e2',
                          width: '105px',
                          padding: '3px',
                        }}
                      >
                        <div>Carrier /</div>
                        <div>Dep Date</div>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid #e2e2e2',
                          borderRight: '1px solid #e2e2e2',
                          color: '#000',
                          fontWeight: '500',
                          backgroundColor: '#f5f5f5',
                          width: '80px',
                          padding: '3px',
                        }}
                      >
                        <div>Flight No</div>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid #e2e2e2',
                          borderRight: '1px solid #e2e2e2',
                          color: '#000',
                          fontWeight: '500',
                          backgroundColor: '#f5f5f5',
                          width: '225px',
                          padding: '3px',
                        }}
                      >
                        <div>Departure /</div>
                        <div>Dep Terminal</div>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid #e2e2e2',
                          borderRight: '1px solid #e2e2e2',
                          color: '#000',
                          fontWeight: '500',
                          backgroundColor: '#f5f5f5',
                          width: '225px',
                          padding: '3px',
                        }}
                      >
                        <div>Arrival /</div>
                        <div>Arr Terminal</div>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid #e2e2e2',
                          borderRight: '1px solid #e2e2e2',
                          color: '#000',
                          fontWeight: '500',
                          backgroundColor: '#f5f5f5',
                          width: '70px',
                          padding: '3px',
                        }}
                      >
                        <div>Dep Time/</div>
                        <div>Dep Date</div>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid #e2e2e2',
                          borderRight: '1px solid #e2e2e2',
                          color: '#000',
                          fontWeight: '500',
                          backgroundColor: '#f5f5f5',
                          width: '70px',
                          padding: '3px',
                        }}
                      >
                        <div>Arr Time/</div>
                        <div>Arr Date</div>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid #e2e2e2',
                          color: '#000',
                          fontWeight: '500',
                          backgroundColor: '#f5f5f5',
                          padding: '3px',
                        }}
                      >
                        <div>Duration /</div>
                        <div>Cabin Class</div>
                      </td>
                    </tr>
                    {returnSectorRef.current.length > 0 &&
                      returnSectorRef.current.map((sector, index) => {
                        const finalDestination =
                          returnSectorRef.current[
                            returnSectorRef.current.length - 1
                          ].Destination;
                        return (
                          <React.Fragment
                            key={`${sector.Origin}-${sector.Destination}`}
                          >
                            <tr>
                              <td
                                style={{
                                  padding: '3px',
                                  verticalAlign: 'top',
                                  width: '105px',
                                  borderRight: '1px solid #e2e2e2',
                                }}
                              >
                                <table>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <AppFlightLogo
                                          className="vertical-bottom"
                                          carrier={sector.Carrier.substring(
                                            0,
                                            2,
                                          )}
                                          style={{
                                            width: '25px',
                                            height: '25px',
                                            marginLeft: '5px',
                                          }}
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        {
                                          AIRLINE_NAMES_FOR_CARRIER_CODE[
                                            sector.Carrier.substring(0, 2)
                                          ]
                                        }
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        {formatDate(
                                          getNewDate(sector.JourneyDate),
                                          DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td
                                style={{
                                  padding: '3px',
                                  verticalAlign: 'top',
                                  width: '80px',
                                  borderRight: '1px solid #e2e2e2',
                                }}
                              >
                                <div>
                                  {`${sector.Carrier}-${sector.FlightNumber}`}
                                </div>
                                <div>
                                  {/* Equipment: airbus-321 */}
                                  {sector.Equipment === null
                                    ? ''
                                    : `Equipment: ${sector.Equipment} ${sector.FlightModel}`}
                                </div>
                              </td>
                              <td
                                style={{
                                  padding: '3px',
                                  verticalAlign: 'top',
                                  width: '225px',
                                  borderRight: '1px solid #e2e2e2',
                                }}
                              >
                                <table>
                                  <tbody>
                                    <tr>
                                      <td style={{ color: '#333' }}>
                                        {sector.OriginAirportFullname} (
                                        {sector.Origin})
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ color: '#333' }}>
                                        {getTerminal(
                                          sector.AirportTerminal.split(',')[0],
                                        ) !== ''
                                          ? `Terminal: ${getTerminal(
                                              sector.AirportTerminal.split(
                                                ',',
                                              )[0],
                                            )}`
                                          : ''}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td
                                style={{
                                  padding: '3px',
                                  verticalAlign: 'top',
                                  width: '225px',
                                  borderRight: '1px solid #e2e2e2',
                                }}
                              >
                                <table>
                                  <tbody>
                                    <tr>
                                      <td style={{ color: '#333' }}>
                                        {sector.DestinationAirportFullname} (
                                        {sector.Destination})
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ color: '#333' }}>
                                        {getTerminal(
                                          sector.AirportTerminal.split(',')[1],
                                        ) !== ''
                                          ? `Terminal: ${getTerminal(
                                              sector.AirportTerminal.split(
                                                ',',
                                              )[1],
                                            )}`
                                          : ''}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td
                                style={{
                                  padding: '3px',
                                  verticalAlign: 'top',
                                  width: '70px',
                                  borderRight: '1px solid #e2e2e2',
                                }}
                              >
                                <table>
                                  <tbody>
                                    <tr>
                                      <td style={{ color: '#333' }}>
                                        {formatTimeString(sector.DepartureTime)}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ color: '#333' }}>
                                        {formatDate(
                                          getNewDate(sector.JourneyDate),
                                          DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td
                                style={{
                                  padding: '3px',
                                  verticalAlign: 'top',
                                  width: '70px',
                                  borderRight: '1px solid #e2e2e2',
                                }}
                              >
                                <table>
                                  <tbody>
                                    <tr>
                                      <td style={{ color: '#333' }}>
                                        {formatTimeString(sector.ArrivalTime)}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ color: '#333' }}>
                                        {formatDate(
                                          getNewDate(sector.ArrivalDate),
                                          DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td
                                style={{
                                  padding: '3px',
                                  verticalAlign: 'top',
                                  color: '#333',
                                }}
                              >
                                <div>
                                  {convertTravelTime(sector.SectorDuration)}
                                </div>
                                <div>
                                  {getBookingClassText(sector.BookingClass)}
                                </div>
                              </td>
                            </tr>
                            {sector.Destination !== finalDestination && (
                              <tr>
                                <td
                                  style={{
                                    textAlign: 'center',
                                    color: '#374471',
                                    fontWeight: '500',
                                    backgroundColor: '#fce5e6',
                                  }}
                                  colSpan="7"
                                >
                                  {getConnectingTime(
                                    sector.ArrivalTime,
                                    sector.ArrivalDate,
                                    returnSectorRef.current[index + 1]
                                      .DepartureTime,
                                    returnSectorRef.current[index + 1]
                                      .JourneyDate,
                                  )}{' '}
                                  layover in {sector.Destination}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div
            style={{
              borderRadius: '6px',
              margin: '10px',
              overflow: 'auto',
              border: '1px solid #e2e2e2',
            }}
            className="avoid-page-break-in-print"
          >
            <table
              style={{
                width: '100%',
                fontSize: '11px',
                borderSpacing: '0',
              }}
              className="avoid-page-break-in-print"
            >
              <thead>
                <tr>
                  <td
                    colSpan={9}
                    style={{
                      backgroundColor: appConfig?.clientPrimaryColor,
                      color: '#fff',
                      fontSize: '14px',
                      fontWeight: '500',
                      padding: '3px 16px',
                    }}
                  >
                    Passenger Details
                  </td>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                      fontWeight: '500',
                      width: '300px',
                    }}
                  >
                    Guest Name
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                      fontWeight: '500',
                      width: '70px',
                    }}
                  >
                    Type
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                      fontWeight: '500',
                      width: '70px',
                    }}
                  >
                    Sector
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                      fontWeight: '500',
                    }}
                  >
                    Airline PNR
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                      fontWeight: '500',
                    }}
                  >
                    Ticket Number
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                      fontWeight: '500',
                    }}
                  >
                    FFN Number
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                      fontWeight: '500',
                    }}
                  >
                    Baggage
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                      fontWeight: '500',
                    }}
                  >
                    2D BARCODE
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                      fontWeight: '500',
                    }}
                  >
                    Status
                  </th>
                </tr>
              </thead>
              <tbody
                style={{ fontSize: '11px', color: '#333', fontWeight: '300' }}
              >
                {paxDetailsRef.current.length > 0 &&
                  paxDetailsRef.current.map((pax) => (
                    <tr key={pax.name}>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          textTransform: 'uppercase',
                        }}
                      >
                        {pax.name} <br />
                        {!isEmpty(pax.passport) && (
                          <>
                            <span style={{ fontSize: '10px', color: '#666' }}>
                              Passport:{' '}
                              <span style={{ fontSize: '11px' }}>
                                {pax.passport}
                              </span>
                            </span>
                            <br />
                          </>
                        )}
                        {!isEmpty(pax.dob) && (
                          <>
                            <span style={{ fontSize: '10px', color: '#666' }}>
                              DOB:{' '}
                              <span style={{ fontSize: '11px' }}>
                                {!isEmpty(pax.dob) &&
                                  formatDate(
                                    getNewDate(pax.dob),
                                    DATE_MONTH_YEAR_VIEW_FORMAT,
                                  )}
                              </span>
                            </span>
                            <br />
                          </>
                        )}
                        {!isEmpty(pax.passportExpiry) && (
                          <span style={{ fontSize: '10px', color: '#666' }}>
                            DOE:{' '}
                            <span style={{ fontSize: '11px' }}>
                              {!isEmpty(pax.passportExpiry) &&
                                formatDate(
                                  getNewDate(pax.passportExpiry),
                                  DATE_MONTH_YEAR_VIEW_FORMAT,
                                )}
                            </span>
                          </span>
                        )}
                      </td>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          textTransform: 'capitalize',
                        }}
                      >
                        {pax.paxType}
                      </td>
                      <td style={{ border: '1px solid #e2e2e2', padding: '0' }}>
                        {pax.paxSectors.length > 0 && (
                          <table style={{ width: '100%', borderSpacing: '0' }}>
                            <tbody>
                              {pax.paxSectors.map((paxsector, index) => (
                                <tr key={index}>
                                  <td
                                    height="66px"
                                    style={{
                                      borderBottom:
                                        pax.paxSectors.length - 1 !== index
                                          ? '1px solid #e2e2e2'
                                          : 'none',
                                    }}
                                  >
                                    {paxsector.sectorInfo}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td style={{ border: '1px solid #e2e2e2' }}>
                        {pax.paxJourney.length > 0 && (
                          <table style={{ width: '100%', borderSpacing: '0' }}>
                            <tbody>
                              {pax.paxJourney.map((journey, index) => (
                                <tr key={index}>
                                  <td
                                    height={
                                      index === 0
                                        ? `${pax.onwardsectorsLength * 66}px`
                                        : `${pax.returnsectorsLength * 66}px`
                                    }
                                    style={{
                                      borderBottom:
                                        pax.paxJourney.length - 1 !== index
                                          ? '1px solid #e2e2e2'
                                          : 'none',
                                    }}
                                  >
                                    {journey.journeyPnr}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td style={{ border: '1px solid #e2e2e2' }}>
                        {pax.paxJourney.length > 0 && (
                          <table style={{ width: '100%', borderSpacing: '0' }}>
                            <tbody>
                              {pax.paxJourney.map((journey, index) => (
                                <tr key={index}>
                                  <td
                                    height={
                                      index === 0
                                        ? `${pax.onwardsectorsLength * 66}px`
                                        : `${pax.returnsectorsLength * 66}px`
                                    }
                                    style={{
                                      borderBottom:
                                        pax.paxJourney.length - 1 !== index
                                          ? '1px solid #e2e2e2'
                                          : 'none',
                                    }}
                                  >
                                    {journey.journeyTicket}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          paddingInline: '0',
                        }}
                      >
                        {pax.paxSectors.length > 0 && (
                          <table
                            style={{ width: '100%', borderSpacing: '0' }}
                            className="avoid-page-break-in-print"
                          >
                            <tbody>
                              {pax.paxSectors.map((paxsector, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      height: '66px',
                                      borderBottom:
                                        pax.paxSectors.length - 1 !== index
                                          ? '1px solid #e2e2e2'
                                          : 'none',
                                    }}
                                  >
                                    {paxsector.sectorFFN}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td style={{ border: '1px solid #e2e2e2', padding: '0' }}>
                        {pax.paxSectors.length > 0 && (
                          <table style={{ width: '100%', borderSpacing: '0' }}>
                            <tbody>
                              {pax.paxSectors.map((paxsector, index) => (
                                <tr key={index}>
                                  <td
                                    height="66px"
                                    style={{
                                      borderBottom:
                                        pax.paxSectors.length - 1 !== index
                                          ? '1px solid #e2e2e2'
                                          : 'none',
                                    }}
                                  >
                                    {/* eslint-disable-next-line no-nested-ternary */}
                                    {pax.paxType.toLowerCase() !== 'infant'
                                      ? typeof paxsector?.sectorBaggage ===
                                        'string'
                                        ? paxsector.sectorBaggage.split(',')[0]
                                        : paxsector?.sectorBaggage
                                      : ''}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          paddingInline: '0',
                        }}
                      >
                        {pax.paxSectors.length > 0 && (
                          <table
                            style={{ width: '100%', borderSpacing: '0' }}
                            className="avoid-page-break-in-print"
                          >
                            <tbody>
                              {pax.paxSectors.map((paxsector, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      height: '66px',
                                      borderBottom:
                                        pax.paxSectors.length - 1 !== index
                                          ? '1px solid #e2e2e2'
                                          : 'none',
                                    }}
                                  >
                                    <img
                                      src={`${
                                        appConfig?.appMainUrl
                                      }${paxsector.sectorBarcode.substring(1)}`}
                                      alt=""
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td style={{ border: '1px solid #e2e2e2' }}>
                        {pax.paxJourney.length > 0 && (
                          <table
                            style={{ width: '100%', borderSpacing: '0' }}
                            className="avoid-page-break-in-print"
                          >
                            <tbody>
                              {pax.paxJourney.map((journey, index) => (
                                <tr key={index}>
                                  <td
                                    height={
                                      index === 0
                                        ? `${pax.onwardsectorsLength * 66}px`
                                        : `${pax.returnsectorsLength * 66}px`
                                    }
                                    style={{
                                      borderBottom:
                                        pax.paxJourney.length - 1 !== index
                                          ? '1px solid #e2e2e2'
                                          : 'none',
                                    }}
                                  >
                                    {journey.journeyStatus?.toLowerCase() ===
                                    'confirmed'
                                      ? 'Confirmed'
                                      : journey.journeyStatus}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {hasSSR && (
            <div
              style={{
                border: '1px solid #e2e2e2',
                borderRadius: '6px',
                overflow: 'hidden',
                margin: '10px',
              }}
              className="avoid-page-break-in-print"
            >
              <div style={{ overflowX: 'auto' }}>
                <table width="100%" className="avoid-page-break-in-print">
                  <tr>
                    <td
                      style={{
                        backgroundColor: appConfig?.clientPrimaryColor,
                        padding: '3px 16px',
                        color: '#fff',
                        fontSize: '13px',
                        fontWeight: '600',
                      }}
                    >
                      Passeneger SSR Details
                    </td>
                  </tr>
                </table>
              </div>
              <div style={{ overflowX: 'auto', width: '100%' }}>
                <table
                  style={{
                    width: '100%',
                    fontSize: '12px',
                    borderSpacing: '0',
                  }}
                  className="avoid-page-break-in-print"
                >
                  <thead
                    style={{ fontSize: '11px', backgroundColor: '#f5f5f5' }}
                  >
                    <tr>
                      <th
                        style={{
                          border: '1px solid #e2e2e2',
                          fontWeight: '500',
                          padding: '3px',
                          width: '200px',
                        }}
                      >
                        Guest Name
                      </th>
                      <th
                        style={{
                          border: '1px solid #e2e2e2',
                          fontWeight: '500',
                          padding: '3px',
                          width: '70px',
                        }}
                      >
                        Sector
                      </th>
                      <th
                        style={{
                          border: '1px solid #e2e2e2',
                          fontWeight: '500',
                          padding: '3px',
                          width: '70px',
                        }}
                      >
                        Seat No
                      </th>
                      <th
                        style={{
                          border: '1px solid #e2e2e2',
                          fontWeight: '500',
                          padding: '3px',
                        }}
                      >
                        Meal
                      </th>
                      <th
                        style={{
                          border: '1px solid #e2e2e2',
                          fontWeight: '500',
                          padding: '3px',
                        }}
                      >
                        Excess Baggage
                      </th>
                      <th
                        style={{
                          border: '1px solid #e2e2e2',
                          fontWeight: '500',
                          padding: '3px',
                          width: '70px',
                        }}
                      >
                        Other SSr
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: '11px', fontWeight: '300' }}>
                    {paxDetailsRef.current.length > 0 &&
                      paxDetailsRef.current.map((pax) => (
                        <tr key={pax.name}>
                          <td
                            style={{
                              border: '1px solid #e2e2e2',
                              textTransform: 'uppercase',
                            }}
                          >
                            {pax.name}
                          </td>
                          <td
                            style={{
                              border: '1px solid #e2e2e2',
                              padding: '3px',
                            }}
                          >
                            {pax.paxSectors.length > 0 && (
                              <table
                                style={{ width: '100%', borderSpacing: '0' }}
                              >
                                <tbody>
                                  {pax.paxSectors.map((paxsector, index) => (
                                    <tr key={paxsector.sectorInfo}>
                                      <td
                                        style={{
                                          borderBottom:
                                            pax.paxSectors.length - 1 !== index
                                              ? '1px solid #e2e2e2'
                                              : 'none',
                                        }}
                                      >
                                        {paxsector.sectorInfo}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </td>
                          <td
                            style={{
                              border: '1px solid #e2e2e2',
                              padding: '3px',
                            }}
                          >
                            {pax.paxSectors.length > 0 && (
                              <table
                                style={{ width: '100%', borderSpacing: '0' }}
                              >
                                <tbody>
                                  {pax.paxSectors.map((paxsector, index) => (
                                    <tr key={paxsector.sectorInfo}>
                                      {paxsector.sectorSSr[0].length > 0 && (
                                        <td
                                          style={{
                                            borderBottom:
                                              pax.paxSectors.length - 1 !==
                                              index
                                                ? '1px solid #e2e2e2'
                                                : 'none',
                                          }}
                                        >
                                          {paxsector.sectorSSr[0].join(',')}{' '}
                                          {getValueFromAppConfig(
                                            'SHOW_SEAT_ERP_NO',
                                          ) !== 'true' &&
                                            paxsector.sectorSSr[4].join(',')}
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </td>
                          <td
                            style={{
                              border: '1px solid #e2e2e2',
                              padding: '3px',
                            }}
                          >
                            {pax.paxSectors.length > 0 && (
                              <table
                                style={{ width: '100%', borderSpacing: '0' }}
                              >
                                <tbody>
                                  {pax.paxSectors.map((paxsector, index) => (
                                    <tr key={paxsector.sectorInfo}>
                                      {paxsector.sectorSSr[1].length > 0 && (
                                        <td
                                          style={{
                                            borderBottom:
                                              pax.paxSectors.length - 1 !==
                                              index
                                                ? '1px solid #e2e2e2'
                                                : 'none',
                                          }}
                                        >
                                          {paxsector.sectorSSr[1].join(',')}
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </td>
                          <td
                            style={{
                              border: '1px solid #e2e2e2',
                              padding: '3px',
                            }}
                          >
                            {pax.paxSectors.length > 0 && (
                              <table
                                style={{ width: '100%', borderSpacing: '0' }}
                              >
                                <tbody>
                                  {pax.paxSectors.map((paxsector, index) => (
                                    <tr key={paxsector.sectorInfo}>
                                      {paxsector.sectorSSr[2].length > 0 && (
                                        <td
                                          style={{
                                            borderBottom:
                                              pax.paxSectors.length - 1 !==
                                              index
                                                ? '1px solid #e2e2e2'
                                                : 'none',
                                          }}
                                        >
                                          {paxsector.sectorSSr[2].join(',')}
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </td>
                          <td
                            style={{
                              border: '1px solid #e2e2e2',
                              padding: '3px',
                            }}
                          >
                            {pax.paxSectors.length > 0 && (
                              <table
                                style={{ width: '100%', borderSpacing: '0' }}
                              >
                                <tbody>
                                  {pax.paxSectors.map((paxsector, index) => (
                                    <tr key={paxsector.sectorInfo}>
                                      {paxsector.sectorSSr[3].length > 0 && (
                                        <td
                                          style={{
                                            borderBottom:
                                              pax.paxSectors.length - 1 !==
                                              index
                                                ? '1px solid #e2e2e2'
                                                : 'none',
                                          }}
                                        >
                                          {paxsector.sectorSSr[3].join(',')}
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {showFare && (
            <div
              style={{
                margin: '10px',
                borderRadius: '6px',
                overflow: 'hidden',
                border: '1px solid #e2e2e2',
              }}
              className="avoid-page-break-in-print"
            >
              <div style={{ overflowX: 'auto' }}>
                <table width="100%" className="avoid-page-break-in-print">
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundColor: appConfig?.clientPrimaryColor,
                          color: '#fff',
                          fontSize: '13px',
                          fontWeight: '600',
                          padding: '3px 16px',
                        }}
                      >
                        Fare Details
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <table
                style={{
                  width: '100%',
                  fontSize: '11px',
                  borderSpacing: '0',
                }}
                className="avoid-page-break-in-print"
              >
                <thead
                  style={{ backgroundColor: '#f5f5f5', fontWeight: '500' }}
                >
                  <tr>
                    <th
                      style={{
                        border: '1px solid #e2e2e2',
                        fontWeight: '500',
                        padding: '3px',
                      }}
                    >
                      Base Fare
                    </th>
                    <th
                      style={{
                        border: '1px solid #e2e2e2',
                        fontWeight: '500',
                        padding: '3px',
                      }}
                    >
                      K3 TAX
                    </th>
                    <th
                      style={{
                        border: '1px solid #e2e2e2',
                        fontWeight: '500',
                        padding: '3px',
                      }}
                    >
                      Taxes & Surcharge
                    </th>
                    <th
                      style={{
                        border: '1px solid #e2e2e2',
                        fontWeight: '500',
                        padding: '3px',
                      }}
                    >
                      Other Charges
                    </th>
                    <th
                      style={{
                        border: '1px solid #e2e2e2',
                        fontWeight: '500',
                        padding: '3px',
                      }}
                    >
                      {appConfig?.isIntlClient === 'true' ? 'VAT' : 'GST'}
                    </th>
                    <th
                      style={{
                        border: '1px solid #e2e2e2',
                        fontWeight: '500',
                        padding: '3px',
                      }}
                    >
                      Add On Charges
                    </th>
                    <th
                      style={{
                        border: '1px solid #e2e2e2',
                        fontWeight: '500',
                        padding: '3px',
                      }}
                    >
                      Total Paid
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontWeight: '300', color: '#666' }}>
                  <tr>
                    <td style={{ border: '1px solid #e2e2e2', padding: '3px' }}>
                      {formatCurrency(fareSummaryRef.current.baseFare)}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2', padding: '3px' }}>
                      {formatCurrency(fareSummaryRef.current.kvalue)}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2', padding: '3px' }}>
                      {formatCurrency(
                        fareSummaryRef.current.otherTaxes +
                          fareSummaryRef.current.yq,
                      )}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2', padding: '3px' }}>
                      {formatCurrency(
                        paymentSummaryRef.current.AdditionalMarkup,
                      )}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2', padding: '3px' }}>
                      {formatCurrency(fareSummaryRef.current.gst)}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2', padding: '3px' }}>
                      {formatCurrency(paymentSummaryRef.current.SSRAmount)}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2', padding: '3px' }}>
                      {formatCurrency(paymentSummaryRef.current.TotalAmount)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          {getValueFromAppConfig('SHOWADMINREMARKSINTICKET') === 'true' && (
            <div
              style={{
                margin: '10px',
                borderRadius: '6px',
                overflow: 'hidden',
                border: '1px solid #e2e2e2',
              }}
              className="avoid-page-break-in-print"
            >
              <table width="100%" className="avoid-page-break-in-print">
                <tbody>
                  <tr>
                    <td
                      style={{
                        backgroundColor: appConfig?.clientPrimaryColor,
                        color: '#fff',
                        fontSize: '13px',
                        fontWeight: '600',
                        padding: '3px 16px',
                      }}
                    >
                      Admin Remarks
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                style={{
                  width: '100%',
                  fontSize: '11px',
                  borderSpacing: '0',
                }}
                className="avoid-page-break-in-print"
              >
                <thead
                  style={{ backgroundColor: '#f5f5f5', fontWeight: '500' }}
                >
                  <tr>
                    <th
                      style={{
                        border: '1px solid #e2e2e2',
                        fontWeight: '500',
                        padding: '3px',
                      }}
                    >
                      {flightInvoiceRef.current.FlightRecord.Spare1}
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
          )}
          <div
            style={{ margin: '10px', fontSize: '12px' }}
            className="avoid-page-break-in-print"
          >
            <ul style={{ margin: 0, paddingInlineStart: '18px' }}>
              <li>
                Passengers must carry valid identification documents, including
                passport, national ID, and visa, as required by destination and
                transit country immigration regulations.
              </li>
              <li>
                Compliance with these requirements is the passenger&apos;s
                responsibility.
              </li>
              <li>
                By proceeding with the booking, passengers agree to the
                carriers&apos; general conditions of carriage.
              </li>
              <li>
                For international travel, passengers should complete any
                required vaccinations and comply with customs and other
                formalities.
              </li>
              <li>
                Applicable fare rules, including cancellation, rebooking, and
                associated fees, have been communicated to the passenger.
              </li>
              <li>
                Personal data submitted during booking will be stored
                electronically for accurate processing and customer care.
              </li>
              <li>
                Service fees are non-refundable in the event of cancellation.
              </li>
              <li>
                Passengers must verify their itinerary for schedule changes at
                least 72 hours before departure.
              </li>
              <li>
                By confirming the booking, the passenger acknowledges
                understanding and acceptance of these terms.
              </li>
              <li>
                Carry a valid government-issued photo identification; you will
                need it as proof of identity while checking in. For infants, it
                is mandatory to carry the DOB certificate.
              </li>
              <li>
                For international flights, carrying a passport and related
                visa/travel documents is mandatory.
              </li>
              <li>
                Partial cancellation is not allowed for round trip fares and
                tickets booked under friends and family fare.
              </li>
            </ul>
          </div>

          {/* <section>
            {showGstDetails && (
              <div style={{ marginBottom: '10px' }}>
                <table
                  style={{
                    width: '100%',
                    fontSize: '12px',
                    textAlign: 'center',
                    borderSpacing: '0',
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid #000' }}>GST Number</th>
                      <th style={{ border: '1px solid #000' }}>
                        GST Company Name
                      </th>
                      <th style={{ border: '1px solid #000' }}>Email ID </th>
                      <th style={{ border: '1px solid #000' }}>
                        GST Company Address
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ border: '1px solid #000' }}>
                        {agentDetailsRef.current.Gst_number !== 'null' &&
                        agentDetailsRef.current.Gst_number !== '' &&
                        agentDetailsRef.current.Gst_number !== undefined
                          ? agentDetailsRef.current.Gst_number
                          : '-'}
                      </td>
                      <td style={{ border: '1px solid #000' }}>
                        {agentDetailsRef.current.Gst_holder !== 'null' &&
                        agentDetailsRef.current.Gst_holder !== '' &&
                        agentDetailsRef.current.Gst_holder !== undefined
                          ? agentDetailsRef.current.Gst_holder
                          : '-'}
                      </td>
                      <td style={{ border: '1px solid #000' }}>
                        {agentDetailsRef.current.Gst_email !== 'null' &&
                        agentDetailsRef.current.Gst_email !== '' &&
                        agentDetailsRef.current.Gst_email !== undefined
                          ? agentDetailsRef.current.Gst_email
                          : '-'}
                      </td>
                      <td style={{ border: '1px solid #000' }}>
                        {agentDetailsRef.current.Gst_address !== 'null' &&
                        agentDetailsRef.current.Gst_address !== '' &&
                        agentDetailsRef.current.Gst_address !== undefined
                          ? agentDetailsRef.current.Gst_address
                          : '-'}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </section> */}
        </section>
      )}
      {hasTicket && (
        <section className="hide-in-print ticket-table_button-container d-flex gap-2 flex-wrap justify-content-center">
          <AppButton
            btnText="Show/Hide Fare"
            variant="green"
            onClick={() => setShowFare(!showFare)}
          />
          <AppButton
            btnText="Show/Hide Agency"
            variant="green"
            onClick={() => setShowAgency(!showAgency)}
          />
          <AppButton
            variant="green"
            btnText="Home"
            onClick={() => window.open(`${window.location.origin}/`, '_blank')}
          />
          {getValueFromAppConfig('REQUIRE_MARKUP') !== 'true' && (
            <AppButton
              btnText="Add Markup"
              variant="green"
              onClick={() => setShowMarkupModal(true)}
            />
          )}
          {/* <AppButton
          btnText="Change Baggage"
          variant="green"
          onClick={() => setShowBaggageModal(true)}
        /> */}
          <AppButton
            // disabled
            btnText="Email"
            variant="green"
            onClick={() => setShowEmailModal(true)}
          />
          <AppButton
            btnText="Print"
            variant="green"
            onClick={() => window.print()}
          />
          <AppButton
            // disabled
            btnText="Show PDF"
            variant="green"
            onClick={handleShowPdf}
          />
          <AppButton
            btnText="Per Pax Ticket"
            variant="green"
            onClick={() => setShowPerPaxTicketModal(true)}
          />
          {/* <AppButton
          btnText="Show/Hide GST"
          variant="green"
          onClick={() => setShowGstDetails((prev) => !prev)}
        /> */}
          {/* <AppButton
          disabled
          btnText="WebCheckIn"
          variant="green"
          onClick={() => {}}
        /> */}
        </section>
      )}
      {showMarkupModal && (
        <AppModal
          modalTitle="Add MarkUp"
          showCloseButton
          onModalClose={() => setShowMarkupModal(false)}
        >
          <div>
            <p>Additional Charges to Add</p>
            <div className="d-flex gap-2">
              <AppNumberInput
                onChange={(d) => setMarkupToAdd(d)}
                value={markupToAdd}
                name="markuptoAdd"
                placeholderText=""
                label="Enter Markup"
              />
              <AppButton
                btnText="Add MarkUp"
                onClick={handleAddMarkup}
                variant="outlined"
              />
            </div>
          </div>
        </AppModal>
      )}
      {showBaggageModal && (
        <AppModal
          modalTitle="Add Baggage"
          showCloseButton
          onModalClose={() => setShowBaggageModal(false)}
        >
          <div>
            <div className="d-flex gap-2">
              <AppTextInput
                onChange={(e) => setBaggageToAdd(e.target.value)}
                value={baggageToAdd}
                name="baggageToAdd"
                placeholderText=""
                label="Baggage to add"
              />
              <AppButton
                btnText="Add Baggage"
                onClick={handleAddBaggage}
                variant="outlined"
              />
            </div>
          </div>
        </AppModal>
      )}
      {showEmailModal && (
        <AppModal
          modalTitle="Email Ticket"
          showCloseButton
          onModalClose={() => setShowEmailModal(false)}
        >
          <div>
            <div className="d-flex gap-2">
              <AppTextInput
                onChange={(e) => setToEmail(e.target.value)}
                value={toEmail}
                name="toEmail"
                placeholderText=""
                label="Email to Send"
              />
              <AppButton
                btnText="Send Email"
                onClick={handleSendEmail}
                variant="outlined"
              />
            </div>
          </div>
        </AppModal>
      )}
      {showPerPaxTicketModal && (
        <AppModal
          modalTitle="Per Pax Ticket"
          showCloseButton
          onModalClose={() => setShowPerPaxTicketModal(false)}
        >
          <FlightPerPaxTicketModal
            paxDetails={paxDetailsRef.current}
            agentDetails={agentDetailsRef.current}
            hasSSR={hasSSR}
            onwardSectors={onwardSectorRef.current}
            returnSectors={returnSectorRef.current}
            flightInvoice={flightInvoiceRef.current}
            onDownload={handleDownloadPerPaxTicket}
            fareSummary={fareSummaryRef.current}
            // imageValid={imageValid}
          />
        </AppModal>
      )}
      {showConfirmationPoup && (
        <AppModal
          modalTitle="Confirmation"
          onModalClose={() => setShowConfirmationPopup(false)}
        >
          <div>
            <div className="d-flex flex-column gap-2">
              <span>
                {flightInvoiceRef.current.FlightRecord.BookingStatus.toLowerCase() ===
                'rolledback'
                  ? `${poupMessageInTicket(
                      flightInvoiceRef.current.FlightRecord.BookingStatus,
                    )}`
                  : `Your booking is currently being processed. Please wait for confirmation or rejection before proceeding with any new ticket issuance. For further assistance kindly call ${agentDetailsRef.current.ContactNumber}`}
              </span>
              <div className="d-flex justify-content-end">
                <AppButton
                  btnText="Ok"
                  onClick={() => setShowConfirmationPopup(false)}
                  variant="outlined"
                />
              </div>
            </div>
          </div>
        </AppModal>
      )}
    </section>
  );
}

export default FlightNewTicketPage;
